
    const data = {"name":"src/core/icons/file-find","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M9 13a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3m11 6.59V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.76.83-2.76.83a5 5 0 0 1-5-5 5 5 0 0 1 5-5 5 5 0 0 1 5 5c0 1-.31 1.96-.83 2.75L20 19.59Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            